import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { mainNavbarItems } from "./consts/navbarItems";
import { useLocation, useNavigate } from "react-router-dom";
import { navbarStyles } from "./styles";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Navbar = () => {
  const theme = useTheme();

  const navigate = useNavigate();
  const location = useLocation();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!isMobile) {
    return null;
  }
  const getUrl = location.pathname + location.search;
  return (
    <Drawer sx={navbarStyles.drawer} variant="permanent" anchor="bottom">
      <List sx={navbarStyles.list}>
        {mainNavbarItems.map((item, index) => (
          <ListItem
            key={index}
            onClick={() => navigate(item.route)}
            sx={navbarStyles.listItem}
          >
            <ListItemIcon
              sx={{
                ...navbarStyles.icons,
                color: getUrl === item.route ? "#009ef7" : "#8e8fa1",
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              sx={{
                ...navbarStyles.text,
                color: getUrl === item.route ? "#ffffff" : "#8e8fa1",
              }}
              primary={item.label}
            />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Navbar;
